import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators
} from '@angular/forms';

type ChangeCallbackFn<T> = (value: T) => void;
type TouchCallbackFn = () => void;

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AddressFormComponent),
      multi: true
    }
  ]
})
export class AddressFormComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() horizontal: boolean = false;
  @Input() countries: Record<string, any>[] = [];
  @Input() address: Record<string, any>;

  addressFormGroup: FormGroup = this.fb.group({
    streetNumber: ['', Validators.required],
    streetName: ['', Validators.required],
    city: ['', Validators.required],
    state: ['', Validators.required],
    zip: ['', Validators.required],
    country: ['', Validators.required]
  });

  onTouched: () => void = () => { };

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initForm();
  }

  public initForm(): void {    
    if (this.address) {
      this.addressFormGroup.setValue(this.address);
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.addressFormGroup.valid) {
      return null;
    }
    return { invalidForm: { valid: false, message: 'addressForm fields are invalid' } };
  }

  writeValue(val: any): void {
    if (val) {
      this.addressFormGroup.setValue(val, { emitEvent: false });
    }
  }

  registerOnChange(fn: ChangeCallbackFn<object>): void {
    this.addressFormGroup.valueChanges.subscribe(fn);

  }
  registerOnTouched(fn: TouchCallbackFn): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.addressFormGroup.disable();
    } else {
      this.addressFormGroup.enable();
    }
  }
}